import React, {useEffect} from "react";
import StickyHeaderDataTable from "../shared/sticky-header-data-table";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";

import Loader from "../loader";
import {FiltersTargets} from "./metrics-utilization-filters";
import currencyFormatter from "../../helpers/currencyFormatter";

export const MetricsType = {
  byAircraftType: 'byAircraftType', byAircraftModel: 'byAircraftModel',
};

const TableName = {
  [FiltersTargets.OFR]: {
    [MetricsType.byAircraftType]: "OFRs by Aircraft Types",
    [MetricsType.byAircraftModel]: "OFRs by Aircraft Models",
  }, [FiltersTargets.Contract]: {
    [MetricsType.byAircraftType]: "Contracts by Aircraft Types",
    [MetricsType.byAircraftModel]: "Contracts by Aircraft Models",
  },
};

const MetricsTargetColumnMap = {
  [FiltersTargets.OFR]: "Signed OFRs", [FiltersTargets.Contract]: 'Signed Contracts',
};

const MetricsTypeColumnMap = {
  [MetricsType.byAircraftModel]: {
    name: 'Aircraft Model', selector: 'model',
  }, [MetricsType.byAircraftType]: {
    name: 'Aircraft Type', selector: 'type',
  }
};

const getColumns = ({target, type}) => [{
  name: MetricsTypeColumnMap[type].name,
  selector: MetricsTypeColumnMap[type].selector,
  minWidth: "150px",
  sortable: true
}, {
  name: 'SUM of Duration', selector: 'totalDuration', right: true, minWidth: "100px", sortable: true
}, {
  name: 'SUM of Cost Share',
  selector: 'totalCost',
  right: true,
  minWidth: "100px",
  cell: (row) => {
    if (
      (row?.totalCost || row.totalCost === 0) &&
      !isNaN(row?.totalCost)
    ) {
      return currencyFormatter.format(row.totalCost);
    }

    return '';
  },
  sortable: true
}, {
  name: 'Hourly Rate',
  selector: 'hourlyRate',
  right: true,
  minWidth: "100px",
  cell: (row) => {
    if (
      (row?.hourlyRate || row.hourlyRate === 0) &&
      !isNaN(row?.hourlyRate)
    ) {
      return currencyFormatter.format(row.hourlyRate);
    }

    return '';
  },
  sortable: true
}, {
  name: MetricsTargetColumnMap[target], selector: 'signedCount', right: true, minWidth: "100px", sortable: true
}];

export const MetricsUtilizationTable = ({
                                          target,
                                          type,
                                          rows = [],
                                          grandTotalDuration,
                                          grandTotalCost = [],
                                          isLoading,
                                          fetchData,
                                          pagination,
                                          sorting,
                                          parentDispatch
                                        }) => {
  const columns = getColumns({target, type});

  const handlePageChange = (page) => {
    parentDispatch({
      type: "pageChanged",
      payload: {
        page,
        target,
        type
      },
    });
  };

  const handleRowsPerPageChange = (countPerPage) => {
    parentDispatch({
      type: "rowsPerPageChanged",
      payload: {
        countPerPage,
        target,
        type,
      },
    });
  };

  const handleSort = (column, sortDirection) => {
    parentDispatch({
      type: "sortingChanged",
      payload: {
        sortBy: column.selector,
        sortDirection,
        target,
        type,
      }
    });
  }

  useEffect(() => {
    fetchData({
      target,
      partialLoad: [type]
    })
  }, [
    pagination.currentPage,
    pagination.countPerPage,
    sorting.sortBy,
    sorting.sortDirection,
    target,
    type
  ]);

  return (
    <Box>
      <Stack direction="row" alignItems="baseline" gap={2}>
        <h5>{TableName[target][type]}</h5>
        {!!rows?.length && !isLoading &&
          <Typography fontWeight="bold" fontSize="13px">
            ({grandTotalDuration}h | {currencyFormatter.format(grandTotalCost)})
          </Typography>
        }
      </Stack>

      <div
        className="server-pagination-table-container metrics-table-container data-table-compact-view shadow-none mt-2">
        <StickyHeaderDataTable
          className="metrics-table"
          columns={columns}
          data={rows ?? []}
          persistTableHead
          progressPending={isLoading}
          progressComponent={<Loader additionalClasses="metrics-table-loader"/>}

          // pagination
          pagination
          paginationServer
          paginationTotalRows={pagination.totalItems}
          paginationPerPage={pagination.countPerPage}
          paginationDefaultPage={pagination.currentPage}
          paginationRowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          paginationResetDefaultPage={false}

          // sorting
          sortServer
          onSort={handleSort}
          defaultSortField={sorting.sortBy}
          sortDirection={sorting.sortDirection}
        />
      </div>
    </Box>
  );
}